import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Stack from '@mui/material/Stack';
import Chip from '@mui/material/Chip';
import { useNavigate } from 'react-router-dom';
import BtnOutlineGradient from 'src/components/common/button/BtnOutlineGradient';
import { getToken } from 'src/utils/auth';
import { postFormDataAPI } from 'src/utils/api';
import ConfirmDelete from 'src/components/common/modal/ConfirmDelete';
import { useState } from 'react';
import { useNotify } from 'src/context/ContextNotify';

type RowsProps = {
  item: any;
};

const Rows: React.FC<RowsProps> = (props) => {
  const notifyContext = useNotify();
  const navigate = useNavigate();
  const dataRow = props.item;
  const [openConfirm, setOpenConfirm] = useState(false);
  const [deleteTimeId, setDeleteTimeId] = useState(0);

  const handleRowClick = () => {
    navigate(`/master/time-edit?id=${dataRow.id}&doctorid=${dataRow.doctorid}`);
  };

  const handleCloseConfirmDelete = () => {
    setOpenConfirm(false);
  };
  const handleDeleteClick = (id: number) => {
    setOpenConfirm(true);
    setDeleteTimeId(id);
  };

  const handleDelete = () => {
    setOpenConfirm(false);
    const token = getToken();
    const formData = new FormData();
    formData.append('id', deleteTimeId.toString());

    try {
      postFormDataAPI(`/master/time-delete?token=${token}`, formData).then(
        (res) => {
          if (res.code === 200) {
            notifyContext.setNotifyMessage({
              show: true,
              message: '削除しました。',
              type: 'success',
            });
            navigate(`/master/time?doctorid=${dataRow.doctorid}`);
          }
          if (res.code === 500 || res.code === 501) {
            notifyContext.setNotifyMessage({
              show: true,
              message: res.msg,
              type: 'error'
            });
          }
        }
      );
    } catch (error) {
      console.error('Failed to delete data:', error);
      return;
    }
  };

  return (
    <>
      <TableRow
        hover
        sx={{
          '&:last-child td, &:last-child th': { border: 0 },
          cursor: 'pointer',
        }}
      >
        <TableCell onClick={handleRowClick}>{dataRow.category}</TableCell>
        <TableCell onClick={handleRowClick}>{dataRow.type}</TableCell>
        <TableCell onClick={handleRowClick}>
          {dataRow.times.map((time: any, index: number) => {
            return <Chip key={index} label={`${time.start} ~ ${time.end}`} variant="outlined" sx={{mr: '4px', mb: '4px'}}/>
          })}
          
        </TableCell>
        <TableCell onClick={handleRowClick} align='right'>
          {dataRow.mintime ? `${dataRow.mintime} 分` : '*見積もりに記載'}
        </TableCell>
        <TableCell onClick={handleRowClick} align='right'>
          {dataRow.visittime ? `${dataRow.visittime} 分` : ''}
        </TableCell>
        <TableCell>
          <Stack direction='row' spacing='8px'>
            <BtnOutlineGradient
              text='変更'
              handleButtonClick={handleRowClick}
            />
            <BtnOutlineGradient
              text='削除'
              handleButtonClick={() => handleDeleteClick(dataRow.id)}
              grandient='#DA4453'
              color='#DA4453'
            />
          </Stack>
        </TableCell>
      </TableRow>

      <ConfirmDelete
        openConfirm={openConfirm}
        handleCloseConfirmDelete={handleCloseConfirmDelete}
        handleDelete={handleDelete}
      />
    </>
  );
};

export default Rows;
